// extracted by mini-css-extract-plugin
export default {"SpinInfo":"SpinInfo_SpinInfo__JsLB7"};